
export const EMPTY_DEALERLIST = 'EMPTY_DEALERLIST';
export const MORE_THAN_3_DEALER_SELECTED = 'MORE_THAN_3_DEALER_SELECTED';
export const NO_DEALER_SELECTED = 'NO_DEALER_SELECTED';
export const API_ERROR = 'API_ERROR';